import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';

class ModuleBlockSlider {

  constructor(){
    this.slider = jQuery(`[data-trigger='module-block-slider']`);
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){
        
        this.slider.owlCarousel({
          items:              1,
          nav:                true,
          navText:            ['',''],
          dots:               false,
          navContainerClass:  'owl-nav-block',
          autoplay:           true,
          autoplayTimeout:    5000,
          autoplayHoverPause: true,
          autoHeight:         true,
        });

      }  

    });
  }

}

export const moduleBlockSlider = new ModuleBlockSlider();